import formfailed from '../../../../../assets/images/formfailed.jpg';
import formsuccess from '../../../../../assets/images/formsuccess.jpg';

export const statusMessageObject = {
	success: {
		title: 'Application Successful',
		description: 'Your application has been received and is currently under review. You’ll hear from us shortly with an update.',
		src: formsuccess,
	},
	failed: {
		title: 'Application Failed',
		description:
			'Something went wrong and your application couldn’t be submitted. Please try again shortly or contact support if the issue persists.',
		src: formfailed,
	},
};
